import styled from "@emotion/styled";

export const PageSection = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.gray[200]};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 20px;
  position: relative;
  width: 100%;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
`;

export const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const PageFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  gap: 16px;
`;

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 15px;
`;
